{
  "success": {
    "analyses/setMovable": "Análise atualizada",
    "analyses/moveIntoPlan": "Análise movida para o plano com sucesso",
    "analyses/remove": "Análise desplaneada com sucesso",
    "analysisDefinitions/create": "Nova definição de análise adicionada",
    "analysisDefinitions/edit": "Definição de análise editada",
    "analysisDefinitions/remove": "Definição de análise eliminada",
    "analysisDraft/create": "Novo rascunho de análise adicionado",
    "analysisDraft/edit": "Rascunho de análise editado",
    "samples/delete-unlocked": "Todas as amostras não planeadas eliminadas",
    "assets/remove": "Instrumento eliminado com sucesso",
    "assets/create": "Novo instrumento adicionado",
    "assets/edit": "Instrumento editado",
    "competenceGroups/create": "Novo grupo de competências criado com sucesso",
    "competenceGroups/edit": "Grupo de competências editado com sucesso",
    "competenceGroups/remove": "Grupo de competências eliminado com sucesso",
    "iap/run": "IAP executado com sucesso",
    "iap/runFillInSamples": "Amostras preenchidas com sucesso",
    "integrationSheets/createActionSheet": "Folha adicionada",
    "integrationSheets/createProjectTemplateSheets": "Folha adicionada",
    "integrationSheets/createSampleSheet": "Folha adicionada",
    "integrationSheets/editActionSheet": "Folha editada",
    "integrationSheets/editProjectTemplateSheet": "Folha editada",
    "integrationSheets/editSampleSheet": "Folha editada",
    "integrationSheets/removeActionSheet": "Folha eliminada",
    "integrationSheets/removeProjectTemplateSheet": "Folha eliminada",
    "integrationSheets/removeSampleSheet": "Folha eliminada",
    "integrationSheets/saveSapConversionSheet": "Folha de Importação de Projeto guardada",
    "members/create": "Membro adicionado",
    "members/createAsAdmin": "Membro adicionado",
    "members/edit": "Membro editado",
    "members/archive": "Membro arquivado",
    "projectActions/editPlanned": "Ação de projeto editada",
    "projectActions/move": "Ação de projeto colocada no horário",
    "projectActions/setMovable": "Ação de projeto atualizada",
    "projectActions/setLocation": "Localização atualizada",
    "projectActions/setLocationUnplanned": "Localização atualizada",
    "projectActions/editUnplanned": "Ação de projeto não planeada editada",
    "projectActions/removePlanned": "Projeto desplaneado",
    "projects/create": "Novo projeto adicionado",
    "projects/edit": "Projeto atualizado",
    "projects/remove": "Projeto eliminado",
    "projects/delete-unplanned": "Todos os projetos não planeados eliminados",
    "projects/lockProject": "Projeto bloqueado",
    "projects/unlockProject": "Projeto desbloqueado",
    "projectTemplates/create": "Novo modelo de projeto criado",
    "projectTemplates/createDraft": "Novo rascunho de modelo de projeto criado",
    "projectTemplates/edit": "Modelo de projeto editado",
    "projectTemplates/editDraft": "Rascunho de modelo de projeto editado",
    "projectTemplates/remove": "Modelo de projeto eliminado",
    "whiteTasks/remove": "Tarefa eliminada com sucesso",
    "whiteTasks/create": "Nova tarefa adicionada",
    "whiteTasks/edit": "Tarefa editada com sucesso",
    "whiteTasks/createRecurrence": "Recorrência criada",
    "whiteTasks/removeRecurrence": "Tarefas recorrentes removidas",
    "teamStatus/start": "Modo de Simulação ativado",
    "teamStatus/accept": "Alterações do Modo de Simulação aplicadas",
    "teamStatus/discard": "Alterações do Modo de Simulação descartadas",
    "customers/addCustomer": "Cliente adicionado",
    "customers/editCustomer": "Cliente editado",
    "customers/deleteCustomer": "Cliente eliminado",
    "team/create-api-token": "Token API criado",
    "team/delete-api-token": "Token API eliminado"
  },
  "error": {
    "analyses/remove/ERROR": "Falha ao desplanear análise",
    "analysisDefinitions/create/ERROR": "Falha ao adicionar nova definição de análise",
    "analysisDefinitions/remove/ERROR": "Falha ao eliminar definição de análise",
    "assets/remove/ERROR": "Falha ao eliminar instrumento",
    "assets/create/ERROR": "Falha ao adicionar instrumento",
    "auth/login/ERROR": "Falha ao iniciar sessão",
    "competenceGroups/create/ERROR": "Falha ao criar grupo de competências",
    "competenceGroups/remove/ERROR": "Falha ao eliminar grupo de competências",
    "iap/run/ERROR": "Falha ao executar IAP",
    "iap/runFillInSamples/ERROR": "Falha ao preencher amostras",
    "integrationSheets/createActionSheet/ERROR": "Falha ao adicionar folha",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Falha ao adicionar folha",
    "integrationSheets/createSampleSheet/ERROR": "Falha ao adicionar folha",
    "integrationSheets/editActionSheet/ERROR": "Falha ao editar folha",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Falha ao editar folha",
    "integrationSheets/editSampleSheet/ERROR": "Falha ao editar folha",
    "integrationSheets/removeActionSheet/ERROR": "Ocorreu um erro ao tentar eliminar a folha",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Ocorreu um erro ao tentar eliminar a folha",
    "integrationSheets/removeSampleSheet/ERROR": "Ocorreu um erro ao tentar eliminar a folha",
    "loading/fetchAll/ERROR": "Falha ao carregar",
    "members/create/ERROR": "Falha ao adicionar membro",
    "members/createAsAdmin/ERROR": "Falha ao adicionar membro",
    "members/archive/ERROR": "Falha ao arquivar membro",
    "projectActions/move/ERROR": "Falha ao mover ação para o horário",
    "projectActions/removePlanned/ERROR": "Falha ao desplanear ação",
    "projectActions/setLocation/ERROR": "Falha ao atualizar localização",
    "projectActions/setLocationUnplanned/ERROR": "Falha ao atualizar localização",
    "projects/create/ERROR": "Falha ao adicionar novo projeto",
    "projects/remove/ERROR": "Falha ao eliminar projeto",
    "projects/delete-unplanned/ERROR": "Falha ao eliminar projetos não planeados",
    "projects/lockProject/ERROR": "Falha ao bloquear ações",
    "projectTemplates/create/ERROR": "Falha ao criar novo modelo de projeto",
    "projectTemplates/createDraft/ERROR": "Falha ao criar novo rascunho de modelo de projeto",
    "projectTemplates/remove/ERROR": "Falha ao eliminar modelo de projeto",
    "whiteTasks/remove/ERROR": "Falha ao eliminar tarefa",
    "whiteTasks/create/ERROR": "Falha ao criar",
    "teamStatus/start/ERROR": "Falha ao ativar Modo de Simulação",
    "teamStatus/accept/ERROR": "Falha ao aplicar alterações do Modo de Simulação",
    "teamStatus/discard/ERROR": "Falha ao descartar alterações do Modo de Simulação",
    "customers/deleteCustomer/ERROR": "Não foi possível eliminar o cliente",
    "customers/addCustomer/ERROR": "Não foi possível adicionar o cliente",
    "customers/editCustomer/ERROR": "Não foi possível editar o cliente",
    "team/create-api-token/ERROR": "Não foi possível criar o token API",
    "team/delete-api-token/ERROR": "Não foi possível eliminar o token API"
  },
  "adhoc": {
    "welcomeBack": "Bem-vindo de volta!",
    "noSoundDetected": "Nenhum som detetado. Por favor tente novamente.",
    "noMicrophoneDetected": "Nenhum microfone detetado. Por favor tente novamente.",
    "iapRunning": "Um momento — o IAP para a sua equipa está a ser executado",
    "failedDiscardNotLoggedOut": "Falha ao descartar alterações. A sessão não foi terminada!",
    "cannotDragRecurrentTask": "Não pode arrastar e largar uma tarefa cinza recorrente",
    "cannotMoveImportedTasks": "Não pode mover tarefas importadas",
    "noCheckboxesSelected": "Nenhuma caixa de verificação selecionada",
    "analysisUpdatedRefresh": "Análise atualizada, por favor atualize a página",
    "analysisUpdatedByAnotherUser": "A análise foi atualizada por outro utilizador, por favor atualize a página",
    "copiedToClipboard": "Copiado para a área de transferência",
    "couldNotCopyToClipboard": "Não foi possível copiar para a área de transferência",
    "chooseFirstAction": "Por favor escolha o primeiro {{itemType}}",
    "chooseSecondAction": "Por favor escolha o segundo {{itemType}}",
    "chooseTwoDifferent": "Por favor escolha dois {{itemType}} diferentes",
    "constraintConflicts": "Essa restrição entra em conflito com as existentes",
    "sampleCreated": "Amostra criada",
    "sampleDeleted": "Amostra eliminada",
    "samplesUpdated": "Amostras atualizadas",
    "sampleMarkedDone": "Amostra marcada como concluída",
    "memberPermissionsChanged": "Permissões do membro alteradas",
    "chooseUniqueName": "Por favor escolha um nome único",
    "fillRequiredFields": "Por favor preencha os campos obrigatórios",
    "couldNotDetermineSampleIdDone": "Não foi possível determinar o ID da amostra para marcar como concluída",
    "couldNotDetermineSampleIdDelete": "Não foi possível determinar o ID da amostra para eliminar",
    "couldNotDetermineSampleIdDeleteMissing": "Não foi possível determinar o ID da amostra para eliminar — dados em falta. Verifique a consola para detalhes.",
    "anErrorOccurred": "Ocorreu um Erro",
    "selectFileBeforeSubmitting": "Por favor selecione pelo menos um ficheiro antes de submeter",
    "helpPageUpdated": "Página de ajuda atualizada",
    "processingStarted": "Processamento iniciado",
    "failedLoadingIcalFiles": "Falha ao carregar ficheiros iCalendar",
    "unsortBeforePasting": "Por favor remova a ordenação da tabela antes de colar múltiplas células.",
    "fillAllRequiredFields": "Por favor preencha todos os campos obrigatórios",
    "unsavedChangesConfirmLeave": "Tem alterações não guardadas. Para confirmar que deseja sair, prima o botão voltar novamente.",
    "provideSheetName": "Por favor forneça um Nome de Folha",
    "sheetNameAlreadyExists": "Já existe uma folha com esse nome",
    "provideSheetType": "Por favor forneça um Tipo de Folha",
    "didNotSpellDeleteProperly": "Não escreveu ELIMINAR corretamente",
    "domainMustStartWithAt": "O domínio deve começar com '@'",
    "fillOutRequiredFields": "Por favor preencha os campos obrigatórios",
    "selectValidDates": "Por favor selecione datas válidas",
    "noIapModeSelected": "Nenhum modo IAP selecionado. Por favor selecione um modo.",
    "oneCollaboratorForWorkday": "Apenas um colaborador pode ser selecionado ao marcar o dia de trabalho inteiro",
    "fillRequiredDateTimeFields": "Por favor preencha todos os campos de data e hora obrigatórios",
    "endMustBeAfterStart": "O fim da tarefa deve ser após o início",
    "recurrencesCannotExceed365": "O número de recorrências não pode ser superior a 365",
    "pleaseFillNumberAndInterval": "Por favor preencha o número e o intervalo de recorrências",
    "pleaseFillNumberOfRecurrences": "Por favor preencha o número de recorrências",
    "pleaseFillIntervalOfRecurrences": "Por favor preencha o intervalo de recorrências",
    "pleaseFillAllPeriodFields": "Por favor preencha todos os campos do período",
    "pleaseSelectReportType": "Por favor selecione pelo menos um tipo de relatório",
    "reportEmptyInInterval": "O {{fileName}} está vazio no intervalo dado",
    "noSoundDetected": "Nenhum som detetado. Por favor tente novamente.",
    "noMicrophoneDetected": "Nenhum microfone detetado. Por favor tente novamente.",
    "promptTooLong": "Prompt demasiado longo (máximo 1200 caracteres)",
    "nameTooLong": "Nome demasiado longo (máximo 100 caracteres)"
  }
}
